import Button from '@berlitz/button'
import { H3, P } from '@berlitz/globals'
import { Cancel, FileUpload } from '@berlitz/icons'
import { Col } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
import { FlagProps } from './interface'

export const StyledDropzone = styled.div<FlagProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-style: dashed;
  outline: none;
  transition: border 0.24s ease-in-out;
  padding: ${({ theme }) => theme.space.md};
  border-width: ${({ theme }) => theme.space.xxxs};
  border-radius: ${({ theme }) => theme.radius.sm};
  border-color: ${({ theme }) => theme.palette.gray100};
  margin-bottom: ${({ theme }) => theme.space.md};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
    `}
`

export const StyledH3 = styled(H3)`
  margin-top: ${({ theme }) => theme.space.sm};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-align: center;
  ${P} {
    font-size: ${({ theme }) => theme.fontSize.xxxs};
    font-style: italic;
  }
`

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.palette.blue100};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.space.sm};
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
`

export const Wrapper = styled.div`
  height: max-content;
`

export const TitleWrapper = styled.div`
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.1px;
  margin-bottom: ${({ theme }) => theme.space.sm};
  color: ${({ theme }) => theme.palette.text00};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const FileContainer = styled.div<{ isLink: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  float: left;
  padding: ${({ theme }) => theme.space.xxxs};
  margin-right: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};
  max-width: 100%;
  ${({ isLink }) =>
    isLink &&
    css`
      cursor: pointer;
    `}
`

export const LinkFileContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  float: left;
  width: 100%;
  padding: ${({ theme }) => theme.space.xxxs};
  margin-right: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};
  cursor: pointer;
`

export const Info = styled.div`
  color: ${({ theme }) => theme.palette.charcoal};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  margin-left: ${({ theme }) => theme.space.xs};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
`

export const CloseContainer = styled.div`
  margin-left: auto;
`

export const CloseButton = styled(Cancel)`
  cursor: pointer;
  margin-top: ${({ theme }) => theme.space.xxxs};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.palette.gray100};
`

export const StyledButton = styled(Button)`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${({ theme }) => theme.layout.sm};
  margin-right: ${({ theme }) => theme.space.sm};
  margin-top: ${({ theme }) => theme.space.sm};
  border: none;

  &:disabled {
    background-color: ${({ theme }) => theme.palette.gray20};
    color: ${({ theme }) => theme.palette.gray100};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ theme }) => theme.layout.sm};
    font-size: ${({ theme }) => theme.fontSize.xxs};
  }
`

export const StyledCol = styled(Col)`
  // padding-right: 0;
  // @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
  //   padding-right: ${({ theme }) => theme.space.sm};
  // }
`

export const StyledFileUpload = styled(FileUpload)`
  color: ${({ theme }) => theme.palette.blueGray50};
`
